if (!customElements.get('leslis-image-comparison')) {
  customElements.define('leslis-image-comparison', class extends HTMLElement {
    connectedCallback() {
      this.range = this.querySelector('input[type="range"]');
      if (!this.range) return;
      this.update = () => this.style.setProperty('--compare', this.range.value + '%');
      this.range.addEventListener('input', this.update);
      this.range.hidden = false;
      this.update();
    }
    disconnectedCallback() { this.range?.removeEventListener('input', this.update); }
  });
}
